import AssetView from './AssetView'
import Hosts from './Hosts'
import HostDashboard from './HostDashboard'
import HostDetails from './HostDetails'
import HostInsights from './HostInsights'
import ContainerDetails from './ContainerDetails'
import CloudDiscovery from './CloudDiscovery'
import KubernetesDiscovery from './KubernetesDiscovery'
import SnykDiscovery from './SnykDiscovery'
import ContainerListView from './ContainerListView'
import AccountKeyHosts from './AccountKeyHosts'
import AccountKeyContainerListView from './AccountKeyContainerListView'
import ContainerImagesListView from './ContainerImagesListView'

export {
  AssetView,
  Hosts,
  HostDashboard,
  HostDetails,
  HostInsights,
  ContainerDetails,
  CloudDiscovery,
  KubernetesDiscovery,
  SnykDiscovery,
  ContainerListView,
  AccountKeyHosts,
  AccountKeyContainerListView,
  ContainerImagesListView
}



// WEBPACK FOOTER //
// ./src/views/hosts/index.js